import React, { useState } from 'react';
import { FormattedNumber } from 'react-intl';

import PanelItem from '../../../CMSPanel/PanelItem';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../Events.scss';

import type { EventDetails, SelectedEvent } from './EventDetailsTable';
import { ModalType } from './EventDetailsTable';

export interface Progress {
  item: EventDetails;
  onClick: React.Dispatch<React.SetStateAction<SelectedEvent | undefined>>;
}

const EventProgress: React.FC<Progress> = ({ item, onClick }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <PanelItem
      body={[]}
      expanded={expanded}
      expandedTitle={item.title}
      collapsedTitle={item.title}
      element={
        <div>
          <span
            className={styles.eventTitle}
            onClick={() => onClick({ type: ModalType.Details, item })}
          >
            Details
          </span>
          <br />
          {item.payoutsUrl && (
            <>
              <span
                className={styles.eventTitle}
                onClick={() => onClick({ type: ModalType.Prize, item })}
              >
                Prize table
              </span>
              <br />
            </>
          )}
          {item.payoutsUrl && (
            <>
              <span
                className={styles.eventTitle}
                onClick={() => onClick({ type: ModalType.Winner, item })}
              >
                Winners
              </span>
              <br />
            </>
          )}
          {item.seatDrawUrl && (
            <>
              <span
                className={styles.eventTitle}
                onClick={() => onClick({ type: ModalType.SeatDraw, item })}
              >
                Seat draw
              </span>
              <br />
            </>
          )}
          {item.status && (
            <>
              <strong>Status:</strong> {item.status}
              <br />
            </>
          )}
          {item.prizePool && (
            <>
              <strong>Prize pool:</strong> {item.prizePool}
              <br />
            </>
          )}
          {!!item.cap && (
            <>
              <strong>Cap</strong>: <FormattedNumber style="decimal" value={item.cap} />
              <br />
            </>
          )}
          {item.totalEntries && (
            <>
              <strong>Entries:</strong> {item.totalEntries}
              <br />
            </>
          )}
          {item.totalPlayersLeft && (
            <>
              <strong>Total players left:</strong> {item.totalPlayersLeft}
              <br />
            </>
          )}
        </div>
      }
      onClick={() => setExpanded((expanded) => !expanded)}
    />
  );
};

export default EventProgress;
